import { zetApi } from '@zet/network'

import { IRegisterUser } from '../types'

export async function registerUser({
  phoneNumber,
  fullName,
  referralCode,
  utmAttributes,
}: IRegisterUser) {
  const response = await zetApi.post(`/signup/create_profile`, {
    phoneNumber: `91${phoneNumber}`,
    name: fullName,
    referralCode,
    utmAttributes,
  })

  return response
}
